import React from 'react';
import {formatDateTime} from '../../common-utilities/date-utility'

const BatchCheckOutConfirmationPopup = ({ isOpen, onClose, onConfirm, title, message, color, batchData }) => {
  const myStyle = { fontWeight: 'bold', fontStyle: 'italic' };


  // Function to calculate the time difference
  const calculateTimeDifference = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);
    const timeDiff = end.getTime() - start.getTime();

    // Calculate the difference in hours, minutes, and seconds
    const hours = Math.floor(timeDiff / (1000 * 60 * 60));
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

    return `${hours} hours, ${minutes} minutes, ${seconds} seconds`;
  };

  return (
    <>
      {isOpen && (
        <div className="modal is-active">
          <div className="modal-background" onClick={onClose}></div>
          <div className="modal-card">
            <header className="modal-card-head">
              <p className="modal-card-title" style={{ color }}>{title}</p>
              <button className="delete" aria-label="close" onClick={onClose}></button>
            </header>
            <section className="modal-card-body">
              <p style={{ color }}>{message}</p>
              <hr />
              <p><span style={myStyle}>{batchData.batchType}</span> incubation is <span style={myStyle}>{batchData.timeSpan} hours</span>.</p>
              <br />
              <p><span style={{ fontWeight: 'bold' }}>Date/Time In: </span> {formatDateTime(batchData.inTime)}</p>
              <br />
              <p><span style={{ fontWeight: 'bold' }}>Date/Time Out:</span> {formatDateTime(batchData.outTime)}</p>
              <br />
              <p><span style={{ fontWeight: 'bold' }}>Time Difference: </span> {calculateTimeDifference(batchData.inTime, batchData.outTime)}</p>
            </section>
            <footer className="modal-card-foot">
              <button className="button is-success" style={{ marginLeft: '470px' }} onClick={onConfirm}>Yes</button>
              <button className="button is-danger" onClick={onClose}>No</button>
            </footer>
          </div>
        </div>
      )}
    </>
  );
};

export default BatchCheckOutConfirmationPopup;
